// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.addFormBox[data-v-26ff4673] {\n  padding: 20px;\n  height: calc(100vh - 100px);\n  overflow-y: auto;\n}\n.addFooter[data-v-26ff4673] {\n  border-top: 1px solid #ccc;\n  text-align: right;\n  padding: 10px;\n}\n.title[data-v-26ff4673] {\n  padding: 15px 10px;\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
